module.exports = __webpack_public_path__ + "img/notification.f00c67a5.svg";